import SingleSelectComponent from "../../components/single-select/single-select.component";
import DeactivationManagementExcelModel from "../../models/deactivation-management/deactivation-management-excel.model";
import LanguagesUtils from "../../utils/languages";
import ViewBase from "../view-base.view";

export default function DeactivationManagementExcelView() {
  ViewBase.call(this);

  const USER_ACCESS = {
    YES: "Y",
    NO: "N"
  }

  const DEACTIVATION_TYPES = {
    IMEI_SO: "IMEI_SO",
    IMEI_ST: "IMEI_ST",
    IMEI_DISP: "IMEI_DISP",
    SKU_SO_INVOICE: "SKU_SO_INVOICE",
  }

  const STORED_PROCEDURE_CODES = {
    IMEI_SO: "31",
    IMEI_ST: "32",
    IMEI_DISP: "33",
    SKU_SO_INVOICE: "34",
  }

  const UPLOAD_DEACTIVATE_TYPE_PATH = {
    IMEI_SO: "IMEISODeactivation",
    IMEI_ST: "IMEISTDeactivation",
    IMEI_DISP: "IMEIDisplayDeactivation",
    SKU_SO_INVOICE: "SKUSOInvoiceDeactivation",
  }

  const disclaimerAllowDaysMessage = "You are only allowed to deactivate ${$.A} of which sales date occurred in the past ${$.B} day(s).";

  let deactivationTypes = [];
  let selectedDeactivationType = null;

  let userAccess = null;

  let limitedRecords = 0;
  let limitedDays = 0;
  let isChannelSystemAdmin = null;

  let requestId = "";

  let fileInput = null;

  let uploadedResult = null;

  const fetchDeactivationTypes =
    DeactivationManagementExcelModel.getDeactivationTypes;

  const fetchDeactivationRecExcelLimit =
    DeactivationManagementExcelModel.getRecExcelLimit;

  const fetchDeactivationBackDayLimit =
    DeactivationManagementExcelModel.getBackDayLimit;

  const fetchIsChannelSystemAdmin =
    DeactivationManagementExcelModel.isChannelSystemAdmin;

  const handleOnSelectDeactivationType = (selectedType) => {
    selectedDeactivationType = selectedType;

    fileInput = null;
    uploadedResult = null;
    requestId = "";

    let uploadInputEle = document.getElementById("file-upload");
    if (uploadInputEle) {
      uploadInputEle.value = "";
    }

    this.showLoading();

    DeactivationManagementExcelModel.checkAccess(selectedType.code)
      .then((accessRes) => {
        userAccess = accessRes;

        if (accessRes === USER_ACCESS.YES) {
          const shouldFetchChannelSystemAdmin =
            selectedType.code === DEACTIVATION_TYPES.IMEI_SO ||
            selectedType.code === DEACTIVATION_TYPES.SKU_SO_INVOICE;

          Promise.all([
            fetchDeactivationRecExcelLimit(selectedType.code),
            fetchDeactivationBackDayLimit(selectedType.code),
            shouldFetchChannelSystemAdmin
              ? fetchIsChannelSystemAdmin()
              : Promise.resolve(null),
          ]).then(
            ([
              deactivationRecExcelLimitRes,
              deactivationBackDayLimitRes,
              isChannelSystemAdminRes,
            ]) => {
              limitedRecords = deactivationRecExcelLimitRes;
              limitedDays = deactivationBackDayLimitRes;
              isChannelSystemAdmin = isChannelSystemAdminRes;
            }
          );
        }

      })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  }

  const handleChangeRequestId = (e) => {
    requestId = e.target.value;
  }

  const handleChangeFile = (e) => {
    fileInput = e.target.files?.[0];
  };

  const handleCLickDownloadTemplate = () => {
    const storedProcedureCode =
      STORED_PROCEDURE_CODES[selectedDeactivationType.code];

    this.showLoading();

    DeactivationManagementExcelModel.downloadExcelTemplate(
      storedProcedureCode,
      `${selectedDeactivationType?.name}-template`
    )
      .catch((error) => this.handleError(error))
      .finally(() => {
        this.hideLoading();
      });
  };

  const handleClickDownloadFResultFile = (fileId, filename) => {
    this.showLoading();
    DeactivationManagementExcelModel.downloadResult(fileId, filename)
      .catch((err) => {
        this.handleError(err);
      })
      .finally(() => {
        this.hideLoading();
      });
  }

  const handleClickUpload = () => {
    if (fileInput) {
      this.showLoading();

      const deactivationType = UPLOAD_DEACTIVATE_TYPE_PATH[selectedDeactivationType.code]

      const bodyFormData = new FormData();
      bodyFormData.append("uploadedExcel", fileInput);

      DeactivationManagementExcelModel.uploadToDeactivate(deactivationType, bodyFormData, requestId)
        .then((data) => {
          uploadedResult = data;
        })
        .catch((error) => this.handleError(error))
        .finally(() => {
          this.hideLoading();
        });
    }
  }

  const getDeactiveTypeStr = (type) => {
    if (
      type === DEACTIVATION_TYPES.IMEI_SO ||
      type === DEACTIVATION_TYPES.SKU_SO_INVOICE
    ) {
      return "Sellout";
    } else if (type === DEACTIVATION_TYPES.IMEI_ST) {
      return "Sell-thru";
    } else if (type === DEACTIVATION_TYPES.IMEI_DISP) {
      return "Display";
    } else {
      return "";
    }
  };

  const handleInit = () => {
    this.showLoading();
    fetchDeactivationTypes()
      .then((types) => (deactivationTypes = types))
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  }

  return {
    oninit: handleInit,

    view: () => {
      return [
        m(".card.mb-3",
          m(".card-body",

            m(".row.g-2",
              m(".col.col-md-8.col-lg-6.col-xl-4",
                m('.d-md-flex.align-items-md-center',
                  m("span.me-2.text-nowrap", `${this.getText("LT00000929", "Deactivation Type")}:`),
                  m(SingleSelectComponent, {
                    items: deactivationTypes,
                    selectedItem: selectedDeactivationType,
                    onSelect: handleOnSelectDeactivationType,
                  })
                )
              )
            ),

            userAccess === USER_ACCESS.NO &&
            m('.text-center.mt-2.mt-md-4', `You are NOT authorized to access to ${selectedDeactivationType?.name} function!!
            `),

            userAccess === USER_ACCESS.YES &&
            m('.mt-2.mt-md-4',
              m("span",
                m("span.text-danger.fs-5", this.getText("LT00000930", "Disclaimer")),
                m("span", ":")
              ),

              m(".mt-1.fs-5",
                m('span.me-1', "*"),
                m("span.me-2", `${this.getText("LT00000931", "Maximum total of record(s) allowed per excel sheet")}:`),
                m('span', `${limitedRecords}.`)
              ),

              m(".mt-1.fs-5",
                m('span.me-1', "*"),
                m("span.me-2", LanguagesUtils.replacePlaceholder(
                  this.getText("LT00000932", disclaimerAllowDaysMessage),
                  {
                    "${$.A}": getDeactiveTypeStr(selectedDeactivationType.code),
                    "${$.B}": limitedDays
                  }
                )
                )
              ),

              isChannelSystemAdmin && m(".row.g-2.mt-2.mt-md-3",
                m(".col.col-md-8.col-lg-6.col-xl-4",
                  m('.d-md-flex.align-items-md-center',
                    m("span.me-2.text-nowrap", `${this.getText("LT00000933", "Work Req. ID & Requester ID")}:`),
                    m('input.form-control.form-control-bg[type="text"]', {
                      value: requestId,
                      onchange: handleChangeRequestId
                    })
                  )
                )
              ),

              m(".row.g-2.mt-2.mt-md-3",
                m(".col.col-12.col-md-8.col-lg-6.col-xl-4",
                  m('.d-md-flex.align-items-md-center',
                    m("span.me-2.text-nowrap", `${this.getText("LT00000493", "Excel")}:`),
                    m("input#file-upload.form-control[type=file]", {
                      onchange: handleChangeFile,
                    }),
                  )
                ),
                m(".col.col-12.col-md-12.col-lg-6.col-xl-4",
                  m('.d-flex.flex-column.flex-md-row.align-items-md-center.justify-content-md-end.justify-content-lg-start.mt-2.mt-lg-0',
                    m("button.btn.btn-primary[type=submit].mx-md-3",
                      {
                        disabled: !fileInput,
                        onclick: handleClickUpload
                      },
                      this.getText("LT00000290", "Upload")
                    ),
                    m("button.btn.btn-primary.mt-1.mt-sm-0",
                      {
                        onclick: handleCLickDownloadTemplate,
                      },
                      m("i.bi.bi-file-earmark-arrow-down"),
                      this.getText("LT00000220", "Excel Template")
                    )
                  )
                ),
              ),

              uploadedResult && m(".mt-4",
                m(".mt-2",
                  m("span", `${this.getText("LT00000934", "Total Record(s) Deactivated")}: `),
                  m("span", uploadedResult?.successCount),
                  m("span.ms-3[role=button]", { onclick: () => handleClickDownloadFResultFile(uploadedResult?.successFileGUID, `deactivated_${uploadedResult?.successFileGUID}`) }, this.getText("LT00000935", "Download File"))
                ),
                m(".mt-2",
                  m("span", `${this.getText("LT00000795", "Total Record(s) Rejected")}: `),
                  m("span.text-danger", uploadedResult?.rejectedCount),
                  m("span.ms-3[role=button]", { onclick: () => handleClickDownloadFResultFile(uploadedResult?.rejectedFileGUID, `rejected_${uploadedResult?.successFileGUID}`) }, this.getText("LT00000935", "Download File"))
                )
              )
            )
          )
        ),

        this.getBaseViews(),
      ];
    },
  };
}